 import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { Customer, CustomerType, Product } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm, custom } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    standalone: false,
    selector: 'app-product-overview',
    templateUrl: './product-overview.component.html',
    styleUrls: ['./product-overview.component.scss'],
})
export class ProductOverviewComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    router = inject(Router);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    modalService = inject(BsModalService);

    filter: any = {};
    products: Product[];
    customerTypes: CustomerType[];
    isAdmin = false;
    salesPersons: any[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        this.customerTypes = this.uow.lookups.customerTypes;
        const materials = await this.uow.productMaterials.whereActive();
        const locations = await this.uow.productLocations.whereActive();
        const categories = await this.uow.productCategories.whereActive();
        const productUoms = await this.uow.productUnitsOfMeasure.whereActive();
        const mixStrengths = await this.uow.mixStrengths.whereActive();
        await this.getData();
        this.isAdmin = this.auth.hasRole('Products:Admin');
        this.appInfo.pleaseWaitHide();
    }

    rowDoubleClick(e: any) {
        this.open(e.data);
    }

    async getData(take?: number) {
        this.appInfo.pleaseWaitShow();
        this.products = await this.uow.getProducts();
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.filter = {};
    }

    open(product?: Product) {
        this.router.navigate([`/products/${product ? product.id : 'new'}`]);
    }

    async delete(products: Product[]) {
        if (!products || products.length === 0) return;

        const success = await confirm(`Are you sure you want to delete the selected product${products.length > 1 ? 's' : ''}?`, this.appInfo.settings.company);
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        products.forEach((product) => {
            product.deleted = new Date();
            product.deletedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async editType(customers: Customer[]) {
        if (!customers || customers.length === 0) return;

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Edit Customer Type',
                mode: 'selectWithId',
                dialogValueArray: this.customerTypes,
            },
        });

        modalRef.content?.result.subscribe(async (result) => {
            if (result && result.success && result.value) {
                this.appInfo.pleaseWaitShow();
                customers.forEach((customer) => (customer.typeId = result.value));
                await this.uow.commit();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }
}
